const APPLICATION_STATUS_TYPE = {
    ACCEPTED: 'accepted',
    COMPLETED: 'completed',
    INVITED: 'invited',
    INVITED_TO_APPLY: 'invited to apply',
    IN_PROGRESS: 'in-progress',
    PENDING: 'pending',
    RECEIVED: 'received',
    WITHDRAWN: 'withdrawn',
};

export {
    APPLICATION_STATUS_TYPE,
};
